/**
 * Site-wide SEO / social-sharing constants — the ONE place the public site identity lives. Plain ES module with no imports so both the
 * browser bundle (components/common/SEO.jsx) and the Node build step (scripts/prerender-seo.js) use exactly the same values.
 *
 * `url` is the PRODUCTION origin used for canonical URLs, og:url and every absolute image URL — never window.location, so a
 * localhost or preview URL can never leak into shared metadata. Override per deployment with REACT_APP_SITE_URL (browser build) /
 * SITE_URL (prerender step). The default is an assumption based on the client's own image URLs (https://shingare.com/api/uploads/…);
 * confirm it, or set the variable.
 */
export const SITE = {
  name: "Shingare Industries",
  legalName: "Shingare Industries Pvt. Ltd.",
  url: "https://shingare.com",
  defaultTitle: "Shingare Industries | Industrial Tube Tools & Maintenance Equipment",
  defaultDescription:
    "Shingare Industries manufactures industrial tube cleaning, tube expansion, pipe beveling, bolting and maintenance equipment for industries worldwide.",
  defaultImage: "/images/og/shingare-industries-og.jpg",
  defaultImageAlt: "Shingare Industries – Industrial Tube Tools & Maintenance Equipment",
  imageWidth: 1200,
  imageHeight: 630,
  ogImageDir: "/images/og/",
};

/** Resolve the production origin: an env override if given, else SITE.url; no trailing slash. */
export const siteUrl = (envValue) => String(envValue || SITE.url).trim().replace(/\/+$/, "");
